import React from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ListSkeleton from "../Skeleton/ListSkeleton";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "98%",
    background: "#F7F7F7",
  },
  table: {
    width: "98%",
    height: "100%",
    maxHeight: "70vh",
    [theme.breakpoints.down("md")]: {
      maxHeight: "60vh",
    },
  },
}));

export default function DraggableTable({
  columns,
  tableData,
  setTableData,
  rowComponent,
  loading,
}) {
  const classes = useStyles();

  const RowComponent = rowComponent;

  function handleOnDragEnd(result) {
    if (!result.destination) return;
    const itemsCopy = Array.from(tableData);
    const [reorderedItem] = itemsCopy.splice(result.source.index, 1);
    itemsCopy.splice(result.destination.index, 0, reorderedItem);

    setTableData(itemsCopy);
  }

  return (
    <TableContainer className={classes.table} component={Paper}>
      {loading ? (
        <ListSkeleton numRows={10} />
      ) : (
        <Table stickyHeader aria-label="sticky table">
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell align="left" style={{ fontWeight: "bold" }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <Droppable droppableId="items">
              {(provided) => (
                <TableBody
                  style={{ paddingLeft: "0px", listStyleType: "none" }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {tableData.map((data, index) => {
                    return (
                      <Draggable
                        key={index}
                        draggableId={index.toString()}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <RowComponent
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}
                            isDragging={snapshot.isDragging}
                            innerRef={provided.innerRef}
                            columns={columns}
                            element={data}
                            index={index}
                            setTableData={setTableData}
                            tableData={tableData}
                          />
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </TableBody>
              )}
            </Droppable>
          </DragDropContext>
        </Table>
      )}
    </TableContainer>
  );
}
